export default "/7ee56fc642439642e071ad6692a1a8b95a874bf4/b7f7b288dfea02dba26459a2a7b68aed.png";